import PostUserLoginRequest from "@/models/api/user/PostUserLoginRequest";
import { axiosInstance } from "@/plugins/axios";
import { AxiosResponse } from "axios";
import CancellableHelper from "@/requests/CancellableHelper";
import { OfficeSettings } from "@/models/api/OfficeSettings";
import { FormOfPaymentItem } from "@/models/api/FormOfPaymentItem";
import PostRemindPasswordRequest from "@/models/api/user/PostRemindPasswordRequest";
import PostResetPasswordRequest from "@/models/api/user/PostResetPasswordRequest";
import { FORM_OF_PAYMENT_TYPE } from "@/static/formOfPaymentType";

//#region Routes
export const URL_POST_USER_LOGIN = "/User/Login";
export const URL_POST_USER_LOGOUT = "/User/Logout";
export const URL_GET_USER_PERMISSIONS = "/User/Permissions";
export const URL_GET_OFFICE_SETTINGS = "/Office/Settings";
export const URL_GET_OFFICE_FORM_OF_PAYMENTS = "/Office/FormOfPayments";
export const URL_POST_REMIND_PASSWORD = "/User/RemindPassword";
export const URL_POST_RESET_PASSWORD = "/User/ResetPassword";
//#endregion

export const postLogin = (requestBody: PostUserLoginRequest): Promise<AxiosResponse> => {
  return axiosInstance.post(URL_POST_USER_LOGIN, requestBody);
};

export const postLogout = (): Promise<AxiosResponse> => {
  return axiosInstance.post(URL_POST_USER_LOGOUT);
};

export const getPermissions = async (): Promise<AxiosResponse> => {
  return await axiosInstance.get(URL_GET_USER_PERMISSIONS);
};

const _getOfficeSettings = new CancellableHelper<OfficeSettings>(URL_GET_OFFICE_SETTINGS, OfficeSettings);
export const getOfficeSettings = async (): Promise<OfficeSettings> => {
  return await _getOfficeSettings.get();
};

const _getOfficeFormOfPayments = new CancellableHelper<Array<FormOfPaymentItem>>(
  URL_GET_OFFICE_FORM_OF_PAYMENTS,
  FormOfPaymentItem
);
export const getOfficeFormOfPayments = async (type: FORM_OF_PAYMENT_TYPE): Promise<Array<FormOfPaymentItem>> => {
  return await _getOfficeFormOfPayments.get({ formOfPaymentType: type });
};

const _postRemindPassword = new CancellableHelper<void>(URL_POST_REMIND_PASSWORD, null, true);
export const postRemindPassword = async (
  officeId: string,
  recaptchaToken: string,
  request: PostRemindPasswordRequest
): Promise<void> => {
  _postRemindPassword.addHeader("recaptcha", recaptchaToken);
  return await _postRemindPassword.post({ officeId: officeId }, request);
};

const _postResetPassword = new CancellableHelper<void>(URL_POST_RESET_PASSWORD, null, true);
export const postResetPassword = async (officeId: string, request: PostResetPasswordRequest): Promise<void> => {
  return await _postResetPassword.post({ officeId: officeId }, request);
};
